import { admin, admin2 } from '@/api/instance'

const baseUrl = (shopId) => {
  return `/${shopId}/mTag`
}

/**
 * 建立標籤 admin.mTag.create
 * @param {Object} params - 建立參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.name - 標籤名稱
 * @param {boolean} params.isAuto - 是否為自動標籤（手動標籤=false）
 * @param {string[]} [params.mTagGroupIds] - 所屬標籤群組 ID 陣列
 * @returns {Promise<[Object, null] | [null, string, Object]>} [data, errMsg, rawErr]
 */
export const CreateTags = async ({ shopId, name, isAuto = false, mTagGroupIds }) => {
  return await admin2({
    method: 'post',
    url: `${baseUrl(shopId)}`,
    data: {
      name,
      isAuto,
      mTagGroupIds,
    },
  })
}

/**
 * 取得標籤列表 admin.mTag.find
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @param {number} [params.start] - 起始索引
 * @param {number} [params.limit] - 查詢筆數
 * @param {boolean} [params.isSystem] - 是否為系統標籤
 * @param {string} [params.name] - 標籤名稱
 * @param {string} [params.MTagGroupId] - 群組篩選條件
 * @returns {Promise<[Array, null] | [null, string, Object]>} [data, errMsg, rawErr]
 */
export const GetTags = async ({ shopId, start, limit, isSystem, name, MTagGroupId }) => {
  const res = await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}`,
    params: {
      start,
      limit,
      isSystem,
      name,
      MTagGroupId,
    },
  })

  return res
}

/**
 * 取得標籤總數 admin.mTag.count
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} [params.name] - 標籤名稱
 * @param {boolean} [params.isSystem] - 是否為系統標籤
 * @param {string} [params.MTagGroupId] - 群組篩選條件
 * @returns {Promise<[Object, null] | [null, string, Object]>} [data, errMsg, rawErr]
 */
export const GetTagsCount = async ({ shopId, name, isSystem, MTagGroupId }) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/count`,
    params: {
      name,
      isSystem,
      MTagGroupId,
    },
  })
}

/**
 * 取得特定標籤 admin.mTag.findOne
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 標籤 ID
 * @returns {Promise<[Object, null] | [null, string, Object]>} [data, errMsg, rawErr]
 */
export const FindTags = async ({ shopId, id }) => {
  const [res, err, rawErr] = await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}`,
  })

  if (err) {
    return [null, err, rawErr]
  }

  return [{
    ...res,
    MTagGroups: Array.isArray(res?.MTagGroups) ? res.MTagGroups : [],
  }, null]
}

/**
 * 更新標籤 admin.mTag.update
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 標籤 ID
 * @param {string} params.name - 標籤名稱
 * @param {string[]} [params.mTagGroupIds] - 所屬標籤群組 ID 陣列
 * @returns {Promise<Object>} 更新結果
 */
export const UpdateTags = async ({ shopId, id, name, mTagGroupIds }) => {
  const res = await admin({
    method: 'put',
    url: `${baseUrl(shopId)}/${id}`,
    data: {
      name,
      mTagGroupIds,
    },
  })

  return res.data
}

/**
 * 更新標籤 admin.mTag.update
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 標籤 ID
 * @param {string} params.name - 標籤名稱
 * @param {string[]} [params.mTagGroupIds] - 所屬標籤群組 ID 陣列
 * @returns {Promise<[Object, null] | [null, string, Object]>} [data, errMsg, rawErr]
 */
export const UpdateTag = async ({ shopId, id, name, mTagGroupIds }) => {
  return await admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/${id}`,
    data: { name, mTagGroupIds },
  })
}

//= > 刪除標籤
export const DeleteTags = async ({ shopId, id }) => {
  const res = await admin({
    method: 'delete',
    url: `${baseUrl(shopId)}/${id}`,
  })

  return res.data
}

/**
 * 刪除標籤 admin.mTag.destroy
 * 後端在同一 transaction 內建立 MTagBatchHistory(jobType=deleteTag)，
 * Runner 異步執行批次撕標。不回傳歷程 ID
 * @param {Object} params - 刪除參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 標籤 ID
 * @returns {Promise<[Object, null] | [null, string, Object]>} [data, errMsg, rawErr]
 */
export const DeleteTag = async ({ shopId, id }) => {
  return await admin2({
    method: 'delete',
    url: `${baseUrl(shopId)}/${id}`,
  })
}

//= > 標籤受眾數
// export const EstimateTags = async ({ shopId, id }) => {
//   const res = await admin({
//     method: 'get',
//     url: `${baseUrl(shopId)}/${id}/estimate`,
//   })

//   return res.data
// }

//= > 自動標籤
export const AutoTags = async ({ shopId, systemName, name, members }) => {
  const res = await admin({
    method: 'delete',
    url: `${baseUrl(shopId)}/systemUser`,
    data: {
      systemName,
      name,
      members,
    },
  })

  return res.data
}
